import React, { useId } from 'react';

/**
 * ADS checkbox — native input, ADS chrome.
 */
const AdsCheckbox = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  className = '',
  id,
  name,
  ...props
}) => {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <label
      className={['ads-checkbox', disabled ? 'is-disabled' : '', className].filter(Boolean).join(' ')}
      htmlFor={inputId}
    >
      <input
        id={inputId}
        name={name}
        type="checkbox"
        className="ads-checkbox__input"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
      <span className="ads-checkbox__box" aria-hidden />
      {label ? <span className="ads-checkbox__label">{label}</span> : null}
    </label>
  );
};

export default AdsCheckbox;
